/**
 * Report card — supports grid (library tiles) and enterprise (full-width row) layouts.
 */
export default function ReportCard({
  icon: Icon,
  iconTone = "blue",
  title,
  description,
  filters,
  actions,
  footer,
  className = "",
  layout = "grid",
  reportType,
}) {
  if (layout === "enterprise") {
    return (
      <article
        className={`rpt-card rpt-card--enterprise ${className}`.trim()}
        data-report-type={reportType}
      >
        <div className="rpt-card-enterprise__layout">
          <div className="rpt-card-enterprise__info">
            <div
              className={`rpt-card-enterprise__icon rpt-card__icon--${iconTone}`}
              aria-hidden="true"
            >
              <Icon size={28} strokeWidth={2} />
            </div>
            <div className="rpt-card-enterprise__meta">
              <h3 className="rpt-card-enterprise__title">{title}</h3>
              {description && <p className="rpt-card-enterprise__desc">{description}</p>}
            </div>
          </div>
          {filters && <div className="rpt-card-enterprise__filters">{filters}</div>}
          {actions && <div className="rpt-card-enterprise__actions">{actions}</div>}
        </div>
        {footer && <div className="rpt-card__footer">{footer}</div>}
      </article>
    );
  }

  return (
    <article className={`rpt-card ${className}`.trim()} data-report-type={reportType}>
      <div className="rpt-card__head">
        <div className={`rpt-card__icon rpt-card__icon--${iconTone}`} aria-hidden="true">
          <Icon size={16} strokeWidth={2.25} />
        </div>
        <div className="rpt-card__meta">
          <h3 className="rpt-card__title">{title}</h3>
          {description && <p className="rpt-card__desc">{description}</p>}
        </div>
      </div>
      <div className="rpt-card__body">
        {filters && <div className="rpt-card__filters">{filters}</div>}
        {footer && <div className="rpt-card__footer">{footer}</div>}
        {actions && <div className="rpt-card__actions">{actions}</div>}
      </div>
    </article>
  );
}
